define("shared/modifiers/load-image-async", ["exports", "ember-modifier", "later/utils/constants"], function (_exports, _emberModifier, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.ASYNC_IMAGE_LOADING_ATTR = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-modifier",0,"later/utils/constants"eaimeta@70e063a35619d71f
  /**
   * Marks an `<img>` while this modifier is loading its real source behind the
   * placeholder. Consumers that must not capture a placeholder — notably the PDF
   * export in `shared/utils/export-to-pdf` — wait for this attribute to clear.
   */
  const ASYNC_IMAGE_LOADING_ATTR = _exports.ASYNC_IMAGE_LOADING_ATTR = 'data-async-image-loading';

  /**
   *  Modifier to load the src of an image asynchronously.
   *  Show a placeholder image while the image is loading.
   *
   */

  class LoadAsyncModifier extends _emberModifier.default {
    modify(element, _ref) {
      let [processingImageUrl, newSource, onError, onLoad] = _ref;
      if (processingImageUrl) {
        const image = new Image();
        const source = newSource || element.src;
        element.src = processingImageUrl;
        element.setAttribute(ASYNC_IMAGE_LOADING_ATTR, 'true');
        image.onload = () => {
          element.src = source;
          element.removeAttribute(ASYNC_IMAGE_LOADING_ATTR);
          onLoad?.();
        };
        image.onerror = () => {
          element.src = _constants.EMPTY_IMAGE_URL;
          element.removeAttribute(ASYNC_IMAGE_LOADING_ATTR);
          onError?.();
        };
        image.src = source;
      }
    }
  }
  _exports.default = LoadAsyncModifier;
});